'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'bars-staggered';
var width = 512;
var height = 512;
var aliases = ["reorder","stream"];
var unicode = 'f550';
var svgPathData = 'M16 112h416c8.844 0 16-7.156 16-15.1S440.8 80 432 80h-416C7.156 80 0 87.16 0 95.1S7.156 112 16 112zM496 240h-416C71.16 240 64 247.2 64 256s7.156 16 16 16h416C504.8 272 512 264.8 512 256S504.8 240 496 240zM432 400h-416c-8.844 0-16 7.156-16 15.1S7.156 432 16 432h416c8.844 0 16-7.156 16-15.1S440.8 400 432 400z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBarsStaggered = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faBarsStaggered.js
// module id = eP8X
// module chunks = 0